import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { pueblosPuertoRico, categorias } from '../../mocks/pueblos';
import { useProducts } from '../../hooks/useProducts';

const CatalogoPage = () => {
  const [searchParams] = useSearchParams();
  const [filteredProducts, setFilteredProducts] = useState<any[]>([]);
  const [precioMin, setPrecioMin] = useState('');
  const [precioMax, setPrecioMax] = useState('');
  const [condicion, setCondicion] = useState('');
  const [pueblo, setPueblo] = useState(searchParams.get('pueblo') || '');
  const [categoria, setCategoria] = useState(searchParams.get('categoria') || '');
  const { getProducts, loading } = useProducts();

  useEffect(() => {
    document.title = 'Catálogo de Clasificados Puerto Rico | IslaVende - Compra y Vende en PR';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', 'Explora miles de clasificados en Puerto Rico. Electrónica, moda, hogar, autos y más. El mejor marketplace de PR con envío Island Wide a toda la isla. Compra y vende seguro.');
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      const filters: any = {};

      if (searchParams.get('q')) {
        filters.busqueda = searchParams.get('q')!;
      }

      if (pueblo) {
        filters.pueblo = pueblo;
      }

      if (categoria) {
        filters.categoria = categoria;
      }

      if (condicion) {
        filters.estado = condicion.toLowerCase();
      }

      if (precioMin) {
        filters.precioMin = Number(precioMin);
      }

      if (precioMax) {
        filters.precioMax = Number(precioMax);
      }

      const { data } = await getProducts(filters);
      if (data) {
        setFilteredProducts(data);
      }
    };

    fetchProducts();
  }, [searchParams, pueblo, categoria, condicion, precioMin, precioMax]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-8">
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
              Catálogo de Productos
            </h1>
            <p className="text-gray-600 text-base">
              {loading ? 'Buscando productos...' : `${filteredProducts.length} productos encontrados`}
              {searchParams.get('q') && ` para "${searchParams.get('q')}"`}
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
            <aside className="lg:col-span-1">
              <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-200 sticky top-24">
                <h3 className="font-bold text-lg text-gray-900 mb-4">Filtros</h3>

                <div className="space-y-6">
                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Pueblo
                    </label>
                    <select
                      value={pueblo}
                      onChange={(e) => setPueblo(e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:border-cobalt-500 cursor-pointer"
                    >
                      <option value="">Todos</option>
                      {pueblosPuertoRico.map((p) => (
                        <option key={p} value={p}>{p}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Categoría
                    </label>
                    <select
                      value={categoria}
                      onChange={(e) => setCategoria(e.target.value)}
                      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:border-cobalt-500 cursor-pointer"
                    >
                      <option value="">Todas</option>
                      {categorias.map((cat) => (
                        <option key={cat.id} value={cat.id}>{cat.nombre}</option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Condición
                    </label>
                    <div className="space-y-2">
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="condicion"
                          value=""
                          checked={condicion === ''}
                          onChange={(e) => setCondicion(e.target.value)}
                          className="mr-2 cursor-pointer"
                        />
                        <span className="text-sm text-gray-700">Todas</span>
                      </label>
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="condicion"
                          value="Nuevo"
                          checked={condicion === 'Nuevo'}
                          onChange={(e) => setCondicion(e.target.value)}
                          className="mr-2 cursor-pointer"
                        />
                        <span className="text-sm text-gray-700">Nuevo</span>
                      </label>
                      <label className="flex items-center cursor-pointer">
                        <input
                          type="radio"
                          name="condicion"
                          value="Usado"
                          checked={condicion === 'Usado'}
                          onChange={(e) => setCondicion(e.target.value)}
                          className="mr-2 cursor-pointer"
                        />
                        <span className="text-sm text-gray-700">Usado</span>
                      </label>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Rango de Precio
                    </label>
                    <div className="space-y-2">
                      <input
                        type="number"
                        placeholder="Mínimo"
                        value={precioMin}
                        onChange={(e) => setPrecioMin(e.target.value)}
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:border-cobalt-500"
                      />
                      <input
                        type="number"
                        placeholder="Máximo"
                        value={precioMax}
                        onChange={(e) => setPrecioMax(e.target.value)}
                        className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:border-cobalt-500"
                      />
                    </div>
                  </div>

                  <button
                    onClick={() => {
                      setPrecioMin('');
                      setPrecioMax('');
                      setCondicion('');
                      setPueblo('');
                      setCategoria('');
                    }}
                    className="w-full py-2 text-sm font-medium text-cobalt-500 border-2 border-cobalt-500 rounded-lg hover:bg-cobalt-50 transition-colors whitespace-nowrap"
                  >
                    Limpiar Filtros
                  </button>
                </div>
              </div>
            </aside>

            <main className="lg:col-span-3">
              {loading ? (
                <div className="flex justify-center items-center py-20">
                  <div className="w-12 h-12 border-4 border-cobalt-500 border-t-transparent rounded-full animate-spin"></div>
                </div>
              ) : filteredProducts.length === 0 ? (
                <div className="bg-white rounded-xl p-12 text-center shadow-sm border border-gray-200">
                  <i className="ri-search-line text-6xl text-gray-300 mb-4"></i>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    No se encontraron productos
                  </h3>
                  <p className="text-gray-600 text-sm">
                    Intenta ajustar los filtros o buscar algo diferente
                  </p>
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-product-shop>
                  {filteredProducts.map((producto) => (
                    <Link
                      key={producto.id}
                      to={`/producto/${producto.id}`}
                      className="bg-white rounded-xl overflow-hidden border-2 border-gray-100 hover:border-cobalt-500 hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer"
                    >
                      <div className="relative w-full h-56">
                        <img
                          src={producto.fotos?.[0] || 'https://public.readdy.ai/ai/img_res/13fd9c73a6d299753291707ee6597f4a.jpg'}
                          alt={producto.titulo}
                          className="w-full h-full object-cover object-top"
                        />
                        <span className="absolute top-3 right-3 bg-white/95 backdrop-blur-sm px-3 py-1 rounded-full text-xs font-semibold text-gray-700">
                          {producto.estado === 'nuevo' ? 'Nuevo' : 'Usado'}
                        </span>
                      </div>
                      <div className="p-4">
                        <h3 className="font-semibold text-gray-900 mb-2 text-sm line-clamp-2">
                          {producto.titulo}
                        </h3>
                        <div className="flex items-center text-xs text-gray-500 mb-3">
                          <i className="ri-map-pin-line mr-1"></i>
                          {producto.pueblo}
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-2xl font-bold text-cobalt-500">
                            ${producto.precio}
                          </span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </main>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CatalogoPage;
